export default __webpack_public_path__ + "static/media/boilblood.77bd3a07.png";